<template>
  <div class="bg-white rounded p-3 progress-track">
    <h3 class="font-weight-bolder">Quotes Progress</h3>
    <div v-for="(product, index) in dataProgress" :key="product.code || index">
      <base-progress :showLabel="true" :label="product.name" :height="15">
        <template #multipleBars>
          <b-progress-bar
            v-for="(quote, barIndex) in product.quotes"
            :key="barIndex"
            :class="`bg-${quote.color}`"
            :value="quote.rate"
            show-progress
          >
          </b-progress-bar>
        </template>
      </base-progress>
      <div class="text-right">
        <a :href="product.href">See more >>></a>
      </div>
      <hr v-if="index < dataProgress.length - 1" />
    </div>

    <div class="mt-4 status-legend">
      <h5 class="font-weight-bold mb-2">Status definitions</h5>
      <b-row>
        <b-col
          v-for="(item, index) in statusLegend"
          :key="index"
          cols="12"
          md="6"
          class="mb-2"
        >
          <div class="status-legend-item">
            <i
              :class="['fa fa-square', `text-${item.color}`]"
              aria-hidden="true"
            ></i>
            <span class="status-legend-label">{{ item.name }}</span>
            <span class="status-legend-description">{{ item.description }}</span>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getReportingProducts, quotesPathForProduct } from "../../helpers/reportingProducts";
import {
  PROGRESS_STATUSES,
  liveStatusGroupKey,
  normalizeStatus,
  PROGRESS_EXCLUDED_STATUSES,
} from "../../helpers/reportingStatuses";

export default {
  name: "progress-track",
  props: {
    dataChart: {
      type: Array,
      required: true
    },
    reportingProducts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      statusLegend: PROGRESS_STATUSES,
      dataProgress: []
    };
  },
  computed: {
    products() {
      return this.reportingProducts.length
        ? this.reportingProducts
        : getReportingProducts();
    }
  },
  watch: {
    dataChart() {
      this.setProgressBar()
    },
    reportingProducts: {
      deep: true,
      handler() {
        this.setProgressBar()
      }
    }
  },
  methods: {
    setProgressBar() {
      this.dataProgress = this.products.map((product) => {
        const rows = _.filter(
          this.dataChart,
          (item) => item.product === product.Product_code
        );
        return {
          code: product.Product_code,
          name: product.Product_name,
          href: quotesPathForProduct(product),
          quotes: this.filterData(rows),
        };
      });
    },
    filterData(rows) {
      const progressRows = rows.filter(
        (item) => !PROGRESS_EXCLUDED_STATUSES.includes(normalizeStatus(item.status))
      );
      const grouped = _.groupBy(progressRows, (item) =>
        liveStatusGroupKey(item.status)
      );
      return this.statusLegend.map((element) => {
        const matched = grouped[element.key] || [];
        return {
          color: element.color,
          rate: progressRows.length
            ? ((matched.length / progressRows.length) * 100).toFixed(2)
            : 0,
        };
      });
    }
  },
};
</script>

<style scoped>
.progress-track {
  min-height: 30em;
  height: auto;
}

.status-legend-item {
  display: flex;
  flex-direction: column;
  padding-left: 1.25rem;
  position: relative;
}

.status-legend-item .fa-square {
  position: absolute;
  left: 0;
  top: 0.2rem;
}

.status-legend-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.status-legend-description {
  font-size: 0.75rem;
  color: #8898aa;
  line-height: 1.3;
}
</style>
